module.exports = __webpack_public_path__ + "static/media/jm.fcb8c1e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/jm.svg
// module id = 157
// module chunks = 0